export const environment = {
  appTitle: 'Fixation Track',
  applicationInsightsConnectionString: 'InstrumentationKey=ae5daec2-e6e0-45a7-a1f5-8a20ee799215;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=aa7b9b8e-4ba5-491e-bb3e-e55dd997eeed',
  api: {
    uri: 'https://app-hoursfactoryhost-dev.azurewebsites.net',
    scopes: [
      'api://2d367fbc-42d9-41b0-a5b4-004898994dbd/access_via_approle_assignments',
    ]
  },
  production: false,
  enableApplicationInsights: true,
  msalConfig: {
    auth: {
      clientId: '2d367fbc-42d9-41b0-a5b4-004898994dbd',
      authority: 'https://login.microsoftonline.com/426b1bb4-22cd-47b5-85c1-2e6fc62b7c9c', // (tenant id)
    }
  },
  roles: {
    timeTracker: 'TimeTracker',
    invoicer: 'Invoicer',
    forecaster: 'Forecaster'
  },
  graphApi: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  }
};
